import { FormControl, MenuItem, Select } from '@mui/material';
import { sortAlphaNum } from '@src/utils/sortAlphaNum';

export interface FilterSelectOption {
  label: string;
  value: string;
}

interface FilterSelectProps {
  currentValue: FilterSelectOption;
  options: FilterSelectOption[];
  handleChange: (value: string) => void;
}

export default function FilterSelect({
  currentValue,
  options,
  handleChange,
}: FilterSelectProps) {
  const sortedOptions = sortAlphaNum(options, 'label');
  return (
    <FormControl
      sx={{
        width: 150,
      }}
    >
      <Select
        value={currentValue.value}
        onChange={(e) => handleChange(e.target.value)}
        fullWidth
        variant='standard'
        size='small'
        displayEmpty
        renderValue={(selected: string) => {
          const selectedOption = options.find(
            (option) => option.value === selected,
          );
          return selectedOption ? selectedOption.label : '';
        }}
      >
        {sortedOptions.map(({ label, value }, i) => (
          <MenuItem key={i} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
